export const calculateImpressions = (
  budget: number | string | null | undefined,
  cpm: number | string | null | undefined
): number | null => {
  const parsedBudget = Number(budget);
  const parsedCpm = Number(cpm);

  const hasValidInputs =
    Number.isFinite(parsedBudget) && Number.isFinite(parsedCpm) && parsedBudget > 0 && parsedCpm > 0;

  if (!hasValidInputs) {
    return null;
  }

  return Math.round((parsedBudget / parsedCpm) * 1000);
};
